import * as types from './constants';

export function storeLayout(key, layout) {
    return { type: types.STORE_LAYOUT, payload: { key: key, layout: layout} };
}

export function storeLayoutElementList(key, layoutElements) {
    return { type: types.STORE_LAYOUT_ELEMENT_LIST, payload: { key: key, layoutElements: layoutElements} };
}

export function flashError(message) {
    return { type: types.FLASH_MESSAGE, payload: { message: message, type: "error"} };
}

export function flashWarning(message) {
    return { type: types.FLASH_MESSAGE, payload: { message: message, type: "warning"} };
}

export function flashInfo(message) {
    return { type: types.FLASH_MESSAGE, payload: { message: message, type: "info"} };
}

export function flashMessageShow(payload) {
    return { type: types.FLASH_MESSAGE_SHOW, payload: payload };
}

export function flashMessageHide(payload) {
    return { type: types.FLASH_MESSAGE_HIDE, payload: payload };
}



// WEBPACK FOOTER //
// ./src/storeState/ui/actions.js